export default "__VITE_ASSET__C8yyJfBi__"